import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const OWRIntegrationState = {
  owr: {
    searchNavigationsAbortController: null,
  },
}

export const OWRIntegrationActions = {
  searchOWRNavigations: async ({ state }, { searchTerm }) => {
    if (state.owr.searchNavigationsAbortController) {
      state.owr.searchNavigationsAbortController.abort()
      state.owr.searchNavigationsAbortController = undefined
    }

    state.owr.searchNavigationsAbortController = new AbortController()

    return axiosRequest.get(
      '/ext/owr/navigations',
      {
        params: { search: searchTerm },
        signal: state.owr.searchNavigationsAbortController,
      }
    ).
      then(({ data }) => data).
      catch(handleError).
      finally(_ => { state.owr.searchNavigationsAbortController = undefined })
  },

  getOWRNavigation: async (_, { navigationId }) => {
    return axiosRequest.get(`/ext/owr/navigations/${navigationId}`).
      then(({ data }) => data).
      catch(handleError)
  },

  getOWRNavigationDocument: async (_, { documentId, navigationId }) => {
    return axiosRequest.get(`/ext/owr/navigations/${navigationId}/documents/${documentId}`, {
      responseType: 'blob',
    }).
      then(({ data }) => data).
      catch(handleError)
  },

  getOWRNavigationDocumentPreview: async (_, { documentId, navigationId }) => {
    return axiosRequest.get(`/ext/owr/navigations/${navigationId}/documents/${documentId}/preview`, {
      responseType: 'blob',
    }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const OWRIntegrationGetters = {}

export const OWRIntegrationMutations = {}
